import axios from "axios";
import config from "../../config";
import { exportAllUsersExcel, exportUserTraceExcel } from "../../utils/exportSeguimiento";

const baseUrl = config.baseUrl;
const BASE    = "/api/seguimiento_log";

const buildParams = (filters = {}) => {
  const p = new URLSearchParams();
  ["userId", "login", "entidad", "active", "dateFrom", "dateTo", "page", "pageSize"]
    .forEach((k) => { if (filters[k] != null && filters[k] !== "") p.append(k, filters[k]); });
  return p.toString();
};

// ── GET /stats ─────────────────────────────────────────────────────────────
export const fetchStats = async () => {
  try {
    const res = await axios.get(`${baseUrl}${BASE}/stats`);
    return { ok: true, data: res.data.data };
  } catch (err) {
    return { ok: false, message: err.response?.data?.message || "Error al obtener estadísticas" };
  }
};

// ── GET /summary  (lista paginada) ──────────────────────────────────────────
export const fetchSummary = async (filters = {}) => {
  try {
    const res = await axios.get(`${baseUrl}${BASE}/summary?${buildParams(filters)}`);
    return { ok: true, data: res.data.data, meta: res.data.meta };
  } catch (err) {
    return { ok: false, message: err.response?.data?.message || "Error al obtener resumen" };
  }
};

// ── GET /user/:id/summary  (contadores rápidos) ─────────────────────────────
export const fetchUserSummary = async (userId) => {
  try {
    const res = await axios.get(`${baseUrl}${BASE}/user/${userId}/summary`);
    return { ok: true, data: res.data.data };
  } catch (err) {
    return { ok: false, message: err.response?.data?.message || "Usuario no encontrado" };
  }
};

// ── GET /user/:id/trace  (trazabilidad completa como JSON) ─────────────────
export const fetchUserTraceJson = async (userId) => {
  try {
    const res = await axios.get(`${baseUrl}${BASE}/user/${userId}/trace/export`);
    return { ok: true, data: res.data };
  } catch (err) {
    return { ok: false, message: err.response?.data?.message || "Error al obtener trazabilidad" };
  }
};

// ── GET /export/all  (todos los usuarios como JSON) ─────────────────────────
export const fetchAllUsersJson = async (filters = {}) => {
  try {
    const qs = buildParams({ ...filters, pageSize: 2000 });
    const res = await axios.get(`${baseUrl}${BASE}/export/all?${qs}`);
    return { ok: true, data: res.data.data };
  } catch (err) {
    return { ok: false, message: err.response?.data?.message || "Error al obtener datos" };
  }
};

// ── Descarga Excel: trazabilidad de un usuario ──────────────────────────────
export const downloadUserTraceExcel = async (userId, userName) => {
  try {
    const { ok, data, message } = await fetchUserTraceJson(userId);
    if (!ok) return { ok: false, message };
    await exportUserTraceExcel(data, `trazabilidad_${userName || userId}_${Date.now()}.xlsx`);
    return { ok: true };
  } catch (err) {
    return { ok: false, message: err.message || "Error al generar Excel" };
  }
};

// ── Descarga Excel: todos los usuarios con filtros ──────────────────────────
export const downloadExportAllExcel = async (filters = {}) => {
  try {
    const { ok, data, message } = await fetchAllUsersJson(filters);
    if (!ok) return { ok: false, message };
    await exportAllUsersExcel(data, `reporte_accesos_${Date.now()}.xlsx`);
    return { ok: true };
  } catch (err) {
    return { ok: false, message: err.message || "Error al generar Excel" };
  }
};
